import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcMic(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.5 11.563v-5a2.5 2.5 0 0 0-5 0v5a2.5 2.5 0 0 0 5 0m-2.5-9a4 4 0 0 0-4 4v5a4 4 0 0 0 8 0v-5a4 4 0 0 0-4-4",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.25 10.875a.75.75 0 0 1 .75.75v.362a6 6 0 0 0 12 0v-.362a.75.75 0 0 1 1.5 0v.362a7.5 7.5 0 0 1-15 0v-.362a.75.75 0 0 1 .75-.75",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 18.063a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-1.5 0v-2.5a.75.75 0 0 1 .75-.75",
    clipRule: "evenodd"
  }));
}
var IcMic = createNolIcon(/*#__PURE__*/forwardRef(SvgIcMic));

export { IcMic as I };
